import { render, staticRenderFns } from "./ReviewCardList.vue?vue&type=template&id=8be80792&"
import script from "./ReviewCardList.vue?vue&type=script&lang=js&"
export * from "./ReviewCardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports